import ContactIndex from './contact-index';

export default class ContactIndexDesktop extends ContactIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/contact/contact-index.desktop.js